import React, { useState } from 'react';
import { SortedItem } from '../../@types/coupon';
import {
  CustomRadio,
  ModalBackground,
  ModalBody,
  ModalBox,
  ModalHeader,
  ModalTitle,
  ModalWrap,
  SortItem,
  SortItemWrap,
} from '../product/ProductSortModal';

// 이미지 경로
const imgURL = '/images';

export default function CouponSort({
  setIsModal,
  headerText,
  sortKeyword,
  setSortKeyword,
}: {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  headerText: string;
  sortKeyword: string;
  setSortKeyword: React.Dispatch<React.SetStateAction<string>>;
}) {
  const [closing, setClosing] = useState<boolean>(false);

  const sortItem: SortedItem[] = [
    { label: '최신순', value: 'RECENT_PRODUCT', desc: 'DESC' },
    { label: '할인률순', value: 'DISCOUNT', desc: 'DESC' },
  ];
  const closeModal = () => {
    setClosing(true);
    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 300);
  };

  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <ModalTitle>{headerText}</ModalTitle>
          <button className="btn_close" onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt="닫기" />
          </button>
        </ModalHeader>
        <ModalBody>
          <SortItemWrap>
            {sortItem.map((el: any) => {
              return (
                <>
                  <SortItem key={el.value}>
                    <CustomRadio>
                      <input
                        type="radio"
                        value={el.value}
                        name="radioBtn"
                        id={el.label}
                        onChange={() => {
                          setSortKeyword(el.label);
                          closeModal();
                        }}
                        checked={sortKeyword === el.label}
                      />
                      <label htmlFor={el.label}>{el.label}</label>
                      <span className="checkmark"></span>
                    </CustomRadio>
                  </SortItem>
                </>
              );
            })}
          </SortItemWrap>
        </ModalBody>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}
